import ServiceGraphQL from 'src/service/gql-service';
import { updatePaymentMethods } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const UpdatePaymentMethods = (variables) => {
  const params = {
    query: updatePaymentMethods.QUERY,
    variables
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
